<template>
<div>
  <b-alert variant="info" :show="msg != null">{{msg}}</b-alert>
  <b-card title="Configuración"
          tag="article">
    <b-form @submit="onSubmit" @cancel="onCancel">
      <b-row>
        <b-col sm="2"><label for="server">Servidor</label></b-col>
        <b-col sm="10">
          <b-input-group>
            <b-form-input id="server" type="text"
                          v-model="fields.server" placeholder="https://servidor:puerto"></b-form-input>
            <b-input-group-append>
              <b-dropdown text="" variant="primary">
                <b-dropdown-item @click="fields.server = 'https://inspecta2.inmac.work:6984'">
                  <h5 class="mb-1">Servidor Inmac</h5>
                  <small class="text-muted">https://inspecta2.inmac.work:6984</small>
                </b-dropdown-item>
                <b-dropdown-item @click="fields.server = 'https://192.168.137.1:6984'">
                  <h5 class="mb-1">Celular a PC (WiFi)</h5>
                  <small class="text-muted">https://192.168.137.1:6984</small>
                </b-dropdown-item>
                <b-dropdown-item @click="fields.server = 'http://localhost:5984'">
                  <h5 class="mb-1">BD instalada en PC</h5>
                  <small class="text-muted">http://localhost:5984</small>
                </b-dropdown-item>
              </b-dropdown>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-button type="submit" variant="primary">Guardar</b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
  <b-card title="Otras configuraciones"
          tag="article">
    <table class="table">
      <tr>
        <td>Para facilitar la actualización del sistema, puede reiniciar los servicios</td>
        <td><b-button class="float-right" @click="sw" variant="primary">Reiniciar Servicios</b-button></td>
      </tr>
      <tr>
        <td>Página de prueba, no debe ser accedido en campo</td>
        <td><router-link class="float-right btn btn-primary" :to="{ name: 'test' }">Test</router-link></td>
      </tr>
      <tr>
        <td>Log</td>
        <td><router-link class="float-right btn btn-primary" :to="{ name: 'log' }">log</router-link></td>
      </tr>
    </table>
  </b-card>
</div>
</template>
<script>
import Base from './Base.vue'
import PouchDB from 'pouchdb'
import { mapActions } from 'vuex'

export default {
  extends: Base,
  data () {
    return {
      fields: {},
      db: {},
      msg: null
    }
  },
  mounted () {
    this.loadConfig()
  },
  methods: {
    loadConfig () {
      let obj = this
      obj.db = new PouchDB('config')
      obj.db.get('config').then((value) => (obj.fields = value))
    },
    onSubmit () {
      let obj = this
      obj.fields._id = 'config'
      obj.db.put(obj.fields).then(function () {
        obj.init()
        obj.loadConfig()
      })
    },
    onCancel () {
      return null
    },
    ...mapActions([
      'init'
    ]),
    sw () {
      var obj = this
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        var arr = []
        for (let registration of registrations) {
          arr.push(registration.unregister())
        }
        Promise.all(arr).then(function (val) {
          console.log('unregistered')
          window.location.reload(false)
        }).catch(function (err) {
          console.log(err)
          obj.msg = err.toString()
        })
      })
    }
  }
}
</script>
